import { FixedNotification } from '@zk/element-ui';
import { defaults } from 'lodash';
import IssueNoticeCard from '@/components/notice/IssueNoticeCard';
import EpicNoticeCard from '@/components/notice/EpicNoticeCard';
import SprintNoticeCard from '@/components/notice/SprintNoticeCard';
import ImportNoticeCard from '@/components/notice/ImportNoticeCard';
import ImportCommentNoticeCard from '@/components/notice/ImportCommentNoticeCard';
import DashboardConfigNoticeCard from '@/components/notice/DashboardConfigNoticeCard';
import ExportNoticeCard from '@/components/notice/ExportNoticeCard';
import MultiIssueNoticeCard from '@/components/notice/MultiIssueNoticeCard';
import eventBus from '@/plugins/eventBus';
import store from '@/store';
import i18n from 'common-module/src/lang';
import BatchUpdateNoticeCard from '@/components/notice/BatchUpdateNoticeCard';
import AgGridBatchUpdateNoticeCard from '@/components/notice/AgGridBatchUpdateNoticeCard';
import LightweightMembersNoticeCard from '@/components/notice/LightweightMembersNoticeCard';
import ImportMembersNoticeCard from '@/components/notice/ImportMembersNoticeCard';
import ProjectCollaboratorNoticeCard from '@/components/notice/ProjectCollaboratorNoticeCard.vue';
import recorderNotice from './recorderNotice';
import KanbanDashboardSaveCard from '@/components/notice/KanbanDashboardSaveCard';
import VideoCommentNoPermissionNoticeCard from '@/components/notice/VideoCommentNoPermissionNoticeCard';
import RecorderExtensionInstallNoticeCard from '@/components/notice//RecorderExtensionInstallNoticeCard';
import UpgradePaymentNoticeCard from '@/components/notice/UpgradePaymentNoticeCard';
import { userHabitQuery, userHabitRecord } from '@/api/user';
import { checkIsInstallChromeRecorderExtension } from '@/utils/recorderExtension';
import { getCache, setCache } from '@zk/framework-vue';

export const NoticePlace = {
  tr: 'top-right',
  tl: 'top-left',
  br: 'bottom-right',
  bl: 'bottom-left'
};

const VisibleNoticeCards = {
  'top-right': new Set(),
  'top-left': new Set(),
  'bottom-right': new Set(),
  'bottom-left': new Set()
};
const typeCardMap = new Map();

let h;
let root;

export function initNoticeListener(vue) {
  eventBus.$on('global:notice', notice);
  root = vue;
  h = root.$createElement;
  specialHandle();
}

export function destroyNoticeListener() {
  eventBus.$off('global:notice');
}

// 因为当前通知机制的限制，先这么聚合一下消息
function specialHandle() {
  eventBus.$on('issue:add-notice', issue => {
    notice({
      fixedFlag: false,
      title: root.$t('message.createSuccess'),
      message: h(IssueNoticeCard, {
        props: {
          issue,
          root
        }
      })
    });
  });

  eventBus.$on('epic:add-notice', data => {
    notice({
      fixedFlag: false,
      title: root.$t('message.createSuccess'),
      message: h(EpicNoticeCard, {
        props: {
          data,
          root
        }
      })
    });
  });

  eventBus.$on('sprint:add-notice', data => {
    notice({
      fixedFlag: false,
      title: root.$t('message.createSuccess'),
      message: h(SprintNoticeCard, {
        props: {
          data,
          root
        }
      })
    });
  });
  eventBus.$on('dashboard:change-notice', data => {
    notice({
      fixedFlag: false,
      customClass:'dashboardConfigNoticeCard zk-notice-card',
      message: h(DashboardConfigNoticeCard, {
        props: {
          data,
          root
        }
      })
    });
  });
  eventBus.$on('kanban:save-dashboard', data => {
    notice({
      fixedFlag: false,
      title: root.$t('home.todo.saveSuccess'),
      message: h(KanbanDashboardSaveCard, {
        props: {
          data,
          root
        }
      })
    });
  });
  eventBus.$on('issue:import-notice', ({ id, handleNoticeClosed }) => {
    closeType('import');
    notice({
      type: 'import',
      extraClass: 'notice-import',
      handleNoticeClosed,
      fixedFlag: true,
      message: h(ImportNoticeCard, {
        props: {
          id
        }
      }),
      duration: 0
    });
  });
  eventBus.$on('issue:import-comment-notice', ({ id, handleNoticeClosed }) => {
    closeType('import');
    notice({
      type: 'import',
      extraClass: 'notice-import',
      handleNoticeClosed,
      fixedFlag: true,
      message: h(ImportCommentNoticeCard, {
        props: {
          id
        }
      }),
      duration: 0
    });
  });

  eventBus.$on('issue:export-notice', id => {
    closeType('import');
    notice({
      type: 'import',
      extraClass: 'notice-import',
      fixedFlag: true,
      message: h(ExportNoticeCard, {
        props: {
          id
        }
      }),
      duration: 0
    });
  });

  eventBus.$on('issue:batch-update-success', (fieldName, count, callback) => {
    notice({
      fixedFlag: false,
      title: `${fieldName} ${root.$t('edit.update.success')}`,
      message: h(BatchUpdateNoticeCard, {
        props: {
          count,
          callback
        }
      })
    });
  });
  eventBus.$on('issue:ag-grid-batch-update-success', (fieldName, count, callback) => {
    notice({
      fixedFlag: false,
      title: `${fieldName} ${root.$t('edit.update.success')}`,
      message: h(AgGridBatchUpdateNoticeCard, {
        props: {
          count,
          callback
        }
      })
    });
  });
  eventBus.$on('issue:multi-notice', issue => {
    notice({
      fixedFlag: false,
      title: root.$t('message.createSuccess'),
      message: h(MultiIssueNoticeCard, {
        props: {
          issueList: issue,
          root
        }
      })
    });
  });

  eventBus.$on('notice:import-members-notice', ({ id, isProjectSettingPage, showImportMember, isProjectInviteMember }) => {
    closeType('import');
    notice({
      type: 'import',
      extraClass: 'notice-import',
      fixedFlag: true,
      message: h(ImportMembersNoticeCard, {
        props: {
          id,
          isProjectSettingPage,
          showImportMember,
          isProjectInviteMember
        }
      }),
      duration: 0
    });
  });
  eventBus.$on('notice:Lightweight-members-notice', ({ id }) => {
    closeType('import');
    notice({
      type: 'import',
      extraClass: 'notice-import',
      fixedFlag: true,
      message: h(LightweightMembersNoticeCard, {
        props: {
          id
        }
      }),
      duration: 0
    });
  });
  eventBus.$on('notice:recycling-bin-upgrade', () => {
    notice({
      fixedFlag: true,
      duration: 0,
      customClass: 'zk-notice-card zk-right-recorder-notice-card',
      title: root.$t('notice.recorderRight.title'),
      message: h(UpgradePaymentNoticeCard, {
        props: {
          adminContentText: root.$t('notice.recycleBin.adminTips'),
          memberContentText: root.$t('notice.recycleBin.memberTips')
        }
      })
    });
  });
  recorderNotice(notice, h);
}

eventBus.$on('notice:change-project-collaborator', (data) => {
  notice({
    customClass:'project-collaborator-notice-card zk-notice-card',
    title: root.$t('setting.table.extraGift'),
    fixedFlag: false,
    message: h(ProjectCollaboratorNoticeCard, {
      props: {
        data
      }
    })
  });
});

let videoPermissionNotice;
eventBus.$on('video-comment:permission-notice', data => {
  if (videoPermissionNotice && !videoPermissionNotice?.closed) {
    videoPermissionNotice.close();
  }
  videoPermissionNotice = notice({
    fixedFlag: false,
    title: root.$t('notice.upgradeSubscription'),
    message: h(VideoCommentNoPermissionNoticeCard, {
      props: {
        data,
        root
      }
    }),
    customClass:'video-comment-permission-notice-card zk-notice-card'
  });
});
eventBus.$on('driver-show', () => {
  Object.values(VisibleNoticeCards).forEach((set) => {
    set?.forEach((item) => {
      item.close();
    });
  });
});

eventBus.$on('recorder:guide-close', async (isLast) => {
  const LINK_TYPE = 'RECORDER_EXTENSION_INSTALL';
  const DONE = '1';
  const userId = store.state.user.account?.userId;
  const localCache = getCache(LINK_TYPE, 'none')?.split(',') || [];

  // 不是最后一个指引或者指引过(先本地存储找，再用户习惯找)则不再出现气泡
  if (isLast || localCache.includes(String(userId))) {
    return;
  }

  // 这里如果用户安装过，再卸载，没出现过气泡。还再出现一次
  const isInstalled = await checkIsInstallChromeRecorderExtension();
  if (isInstalled) {
    return;
  }

  const res = await userHabitQuery({
    linkType: LINK_TYPE,
    projectId: 0,
    userId
  });

  if (res.result.linkIdList?.[0] === DONE) {
    setCache(LINK_TYPE, [...localCache, userId].join(), { version: 'none' });
    return;
  }

  notice({
    title: '',
    position:'bottom-right',
    duration: 0,
    customClass:'zk-recorder-extension-install-notice',
    message: h(RecorderExtensionInstallNoticeCard)
  });

  userHabitRecord({
    linkIdList: [DONE],
    linkType: LINK_TYPE,
    projectId: 0,
    userId
  });
  setCache(LINK_TYPE, [...localCache, userId].join(), { version: 'none' });
});


function closeType(type) {
  typeCardMap.get(type)?.forEach(card => card.close());
}

export function notice(option) {
  option = defaults(option, {
    position: NoticePlace.bl,
    duration: 5000
  });

  const positionCards = VisibleNoticeCards[option.position];

  if (positionCards) {
    if (positionCards.size >= 3) {
      const firstCard = [...positionCards].find(item => item._option.fixedFlag !== true);
      //const firstCard = nofixedFlagCards.values().next().value;
      if (firstCard){
        firstCard.close();
        positionCards.delete(firstCard);
      }
    }

    const card = FixedNotification({
      customClass: `zk-notice-card ${option.extraClass || ''}`, // 对应的样式在 component/NoticeCard
      ...option,
      onClose: () => {
        card.$emit('closed');
        positionCards.delete(card);
        if (option.type) {
          typeCardMap.get(option.type).delete(card);
        }
        if (typeof option.handleNoticeClosed === 'function'){
          option.handleNoticeClosed();
        }
      }
    }, {
      i18n,
      store
    });
    card._option = option;
    if (option.type) {
      if (!typeCardMap.has(option.type)) {
        typeCardMap.set(option.type, new Set());
      }
      typeCardMap.get(option.type).add(card);
    }
    positionCards.add(card);
    return card;
  }

}
